import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { PreferredCurrencyModule } from '@vendasta/sales-common';
import { OpportunityInfoFormComponent } from './opportunity-info-form/opportunity-info-form.component';
import { OpportunityInfoComponent } from './opportunity-info.component';
// import { SalesWorkflowModule } from '../../../sales-workflow/sales-workflow.module';
import { MatMenuModule } from '@angular/material/menu';
// import { AssigneeSelectorComponent } from './opportunity-info-form/editable-fields/assignee-selector/assignee-selector.component';
import { ExpectedCloseSelectorComponent } from './opportunity-info-form/editable-fields/expected-close-selector/expected-close-selector.component';
// import { SubtitleAssigneesService } from '../../../account-details/sub-title/subtitle-assignees/subtitle-assignees.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { VaFormsModule } from '@vendasta/forms';
// import { OPP_DATE_FORMATS, SalesOpportunitiesModule } from '../../sales-opportunities.module';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { UIKitModule } from '@vendasta/uikit';
import { CloseOpportunityDialogComponent } from './close-opportunity/close-opportunity-dialog/close-opportunity-dialog.component';
import { CloseOpportunityComponent } from './close-opportunity/close-opportunity.component';
import { AssigneeSelectorComponent } from './opportunity-info-form/assignee-selector/assignee-selector.component';
import { PipelineSelectorModule } from './opportunity-info-form/editable-fields/pipeline-selector/pipeline-selector.module';
import { ReopenOpportunityDialogComponent } from './reopen-opportunity/reopen-opportunity-dialog.component';

import { UpdateTypeSelectorComponent } from '../../../type-selector/update-type-selector/update-type-selector.component';
import { ContractDurationSelectorModule } from './opportunity-info-form/editable-fields/contract-duration-selector/contract-duration-selector.module';
import { OpportunityNameComponent } from './opportunity-info-form/editable-fields/opportunity-name/opportunity-name.component';
import { SubscribersSelectorModule } from './opportunity-info-form/editable-fields/subscribers-selector/subscribers-selector.module';

export const OPP_DATE_FORMATS = {
  parse: { dateInput: 'YYYY-MM-DDTHH:mm:ssZ' },
  display: {
    dateInput: 'MMM DD, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    TranslateModule,
    PreferredCurrencyModule,
    // SalesOpportunitiesModule,
    // SalesWorkflowModule,
    MatMenuModule,
    MatIconModule,
    VaFormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    UIKitModule,
    MatButtonModule,
    MatDialogModule,
    GalaxyFormFieldModule,
    UpdateTypeSelectorComponent,
    PipelineSelectorModule,
    ContractDurationSelectorModule,
    SubscribersSelectorModule,
    OpportunityNameComponent,
  ],
  declarations: [
    OpportunityInfoComponent,
    CloseOpportunityDialogComponent,
    CloseOpportunityComponent,
    OpportunityInfoFormComponent,
    ReopenOpportunityDialogComponent,
    AssigneeSelectorComponent,
    ExpectedCloseSelectorComponent,
  ],
  exports: [OpportunityInfoComponent],
  providers: [
    // SubtitleAssigneesService,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    {
      provide: MAT_DATE_FORMATS,
      useValue: OPP_DATE_FORMATS,
    },
  ],
})
export class OpportunityInfoModule {}
